module.exports = __webpack_public_path__ + "static/media/azim-premji-philanthropic-initiatives.f6015b1f.png";